export const PROJECTS_COUNT = {
  phone: 3,
  tablet: 4,
  desktop: 6,
};
